export enum PeriodSelectorEnum {
  now = 'Now',
  day = 'Day',
  week = 'Week',
  month = 'Month',
  schoolYear = 'SchoolYear',
}
